<div class="employee-filter uw-box">
  <uw-employee-search-filter
    (search)="onSearch($event)"
    (clearFilter)="onClearSearchFilter()"
  ></uw-employee-search-filter>
</div>

<div class="align-right mb1">
  <button
    type="submit"
    class="uw-secondary-button uw-button--medium"
    (click)="filterTransactions('allTransactions')"
    >
    {{ filterButtonLabelMap.allTransactions ?? "campaign.all_transactions" | translate }}
  </button>
  <button
    type="submit"
    class="uw-secondary-button uw-button--medium"
    (click)="filterTransactions('sentTransactions')"
    >
    {{ filterButtonLabelMap.sentTransactions ?? "campaign.paid_transactions" | translate }}
  </button>
  <button
    type="submit"
    class="uw-secondary-button uw-button--medium"
    (click)="filterTransactions('unsentTransactions')"
    >
    {{ filterButtonLabelMap.unsentTransactions ?? "campaign.unpaid_transactions" | translate }}
  </button>
</div>

@if (noRecords && !isLoading) {
  <app-no-record-container
    message="{{ 'common.no_record_found' | translate }}"
    >
  </app-no-record-container>
}
@if (!noRecords && !isLoading) {
  <uw-paid-unpaid-transaction-list
    [columnsConfig]="columnsConfig"
    [donationFormGroup]="donationFormGroup"
    [paginationOption]="pagination"
    (page)="onPageChange()"
  ></uw-paid-unpaid-transaction-list>
  <uw-button
    type="submit"
    [loading]="isSaving"
    (buttonClick)="onSubmit()"
    btnLabel="{{ 'buttons.submit' | translate }}"
    >
  </uw-button>
}

@if (isLoading) {
  <div class="d-flex flex-column align-items-center" style="margin-top: 6em;">
    <div style="font-size: 1em;" class="mb-3 font-weight-bold">
      {{'common.fetching_data' | translate}}
    </div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}


<!-- <pre>{{ filter | json }}</pre> -->

